
export interface RespondInterface {
  success: boolean;
  message?: any;
  validations?: any;
  properties?: any;
  errors?: any;
}

export class RespondModel implements RespondInterface {
  success = true;
  message = '';
  validations = [];
  properties = [];
  errors = [];
}



// WEBPACK FOOTER //
// ./src/app/utils/trip2-query-builder/respond-interface.ts